<div class="send-to-anyone">
    <a class="back-link" routerLink="/browse-requests">
        <span class="material-symbols-outlined">arrow_back</span>
        Back to Journeys
    </a>

    <section class="intro-card">
        <div class="intro-card__header">
            <div class="intro-card__avatar">
                <span class="material-symbols-outlined">public</span>
            </div>

            <div class="intro-card__identity">
                <h1>Anyone Who Needs It</h1>

                <div class="intro-card__meta">
                    <span>
                        <span class="material-symbols-outlined">location_on</span>
                        Everywhere
                    </span>
                    <span>
                        <span class="material-symbols-outlined">schedule</span>
                        Always open
                    </span>
                </div>
            </div>
        </div>

        <div class="intro-card__tags">
            <span class="intro-tag">Where It All Began</span>
            <span class="intro-tag intro-tag--success">400+ Cards Received</span>
        </div>

        <p class="intro-card__lead">
            Not sure who to support? Send a message of hope to someone who needs it. We'll match it with a person going through a tough time.
        </p>
        <p>
            Strangers from across the country have been sending handmade greeting cards, letters, and messages of hope to people going through cancer. That spirit of generosity sparked a movement, and WondrVoices now also supports personalized journeys for individuals and families.
        </p>

        <div class="intro-card__stats">
            <div class="stat-chip">
                <span class="material-symbols-outlined">mail</span>
                <strong>400+</strong>
                <span>cards &amp; letters</span>
            </div>
            <!-- <div class="stat-chip">
                <span class="material-symbols-outlined">location_on</span>
                <strong>30+</strong>
                <span>states</span>
            </div>
            <div class="stat-chip">
                <span class="material-symbols-outlined">favorite</span>
                <strong>100+</strong>
                <span>recipients</span>
            </div> -->
        </div>
    </section>

    <section class="origin-story">
        <div class="origin-story__icon">
            <span class="material-symbols-outlined">auto_awesome</span>
        </div>
        <div class="origin-story__content">
            <h3>How It All Started</h3>
            <p>
                Before personalized journeys existed, every card was addressed to "anyone who needs it." Volunteers, families, and students mailed in handwritten notes, watercolor paintings, and letters full of hope. That collection of love became the foundation of everything you see today.
            </p>
        </div>
    </section>

    <section class="kindness-wall">
        <h2>A Growing Wall of Kindness</h2>
        <p class="section-copy">
            Every card here was made by someone who wanted to brighten a stranger's day. Browse a sample of the submissions that started it all.
        </p>

        <div class="wall-grid" *ngIf="visibleWallCards().length > 0; else wallState">
            <a class="wall-card" *ngFor="let card of visibleWallCards()" [routerLink]="['/voices', card.id]">
                <div class="wall-card__image">
                    <img [src]="card.img" [alt]="getVoiceDisplayName(card) + ' card'" loading="lazy">
                </div>
                <div class="wall-card__footer">
                    <span class="wall-card__name">{{ getVoiceDisplayName(card) }}</span>
                    <span class="wall-card__location">
                        <span class="material-symbols-outlined">location_on</span>
                        {{ getVoiceLocation(card) }}
                    </span>
                </div>
            </a>
        </div>

        <ng-template #wallState>
            <div class="wall-empty">
                <p *ngIf="wallLoading()">Loading gallery cards...</p>
                <p *ngIf="!wallLoading()">Gallery cards will appear here shortly.</p>
            </div>
        </ng-template>

        <a routerLink="/gallery" class="outline-button">
            View Full Gallery
            <span class="material-symbols-outlined">arrow_forward</span>
        </a>
    </section>

    <section class="voice-actions">
        <h2>Add Your Voice</h2>
        <p class="section-copy">
            Continue the tradition. Send a message, mail a card, or share your support with someone who needs it.
        </p>

        <div class="actions-panel">
            <div class="action-card">
                <div class="action-card__icon">
                    <span class="material-symbols-outlined">chat_bubble</span>
                </div>
                <div class="action-card__body">
                    <h3>Send a message online</h3>
                    <p>Write a message of hope that will be shared in our community feed.</p>
                    <a routerLink="/submit" class="action-link">
                        Share in the Feed
                        <span class="material-symbols-outlined">arrow_forward</span>
                    </a>
                </div>
            </div>

            <div class="panel-divider"><span>or</span></div>

            <div class="action-card">
                <div class="action-card__icon">
                    <span class="material-symbols-outlined">mail</span>
                </div>
                <div class="action-card__body">
                    <h3>Mail your card or letter</h3>
                    <p>Send handwritten cards, drawings, or letters to:</p>

                    <div class="address-block">
                        <span class="org">WondrVoices</span>
                        <span>PO Box 40056</span>
                        <span>St. Pete, FL 33743</span>
                    </div>

                    <button type="button" class="copy-button" (click)="copyAddress()">
                        <span class="material-symbols-outlined">{{ addressCopied() ? 'check' : 'content_copy' }}</span>
                        {{ addressCopied() ? 'Address copied' : 'Copy address' }}
                    </button>
                </div>
            </div>

            <div class="panel-divider"><span>or</span></div>

            <div class="action-card">
                <div class="action-card__icon">
                    <span class="material-symbols-outlined">smartphone</span>
                </div>
                <div class="action-card__body">
                    <h3>Upload via mobile app</h3>
                    <p>Download the WondrVoices app to submit your support digitally. Take a photo of your handwritten card or create one in the app.</p>

                    <div class="store-links">
                        <a href="https://apps.apple.com/us/app/wondrvoices-share-kindness/id6748359471" target="_blank" rel="noopener noreferrer">
                            <span class="material-symbols-outlined">ios</span>
                            App Store
                        </a>
                        <a href="https://play.google.com/store/apps/details?id=com.fwollo.wondrdrop" target="_blank" rel="noopener noreferrer">
                            <span class="material-symbols-outlined">play_arrow</span>
                            Google Play
                        </a>
                    </div>
                </div>
            </div>

            <div class="panel-divider"><span>or</span></div>

            <div class="action-card">
                <div class="action-card__icon">
                    <span class="material-symbols-outlined">share</span>
                </div>
                <div class="action-card__body">
                    <h3>Spread the Word</h3>
                    <p>Help others discover WondrVoices and join the movement of spreading hope.</p>

                    <div class="social-links">
                        <a href="https://x.com/wondrvoices" target="_blank" rel="noopener noreferrer" aria-label="WondrVoices on X">
                            <img src="assets/svg/x.svg" alt="X">
                        </a>
                        <a href="https://www.facebook.com/WondrVoices" target="_blank" rel="noopener noreferrer" aria-label="WondrVoices on Facebook">
                            <img src="assets/svg/fb.svg" alt="Facebook">
                        </a>
                        <a href="https://www.instagram.com/wondrvoices" target="_blank" rel="noopener noreferrer" aria-label="WondrVoices on Instagram">
                            <img src="assets/svg/inst.svg" alt="Instagram">
                        </a>
                        <a href="https://www.linkedin.com/company/wondrvoices" target="_blank" rel="noopener noreferrer" aria-label="WondrVoices on LinkedIn">
                            <img src="assets/svg/linkedin.svg" alt="LinkedIn">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="journeys-footer">
        <p>Want to support a specific person or family? Browse personalized journeys.</p>
        <a routerLink="/browse-requests" class="outline-button outline-button--journeys">
            Browse Personalized Journeys
            <span class="material-symbols-outlined">arrow_forward</span>
        </a>
    </section>
</div>
